module.exports = __webpack_public_path__ + "static/img/funny_13.1753e713.jpg";